import React, { Component } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import Navbar from '../Navbar.jsx';
import EUNavbar from '../EndUser/EU-Navbar';
import ModalRoutes from './ModalRoutes';

import axios from "axios";
import { LoadingIcon } from '../Common/Loading_Icon';
import {constants} from "../../Helpers/Constants";
import { Trans } from 'react-i18next';
import {
    Accordion,
    AccordionItem,
    AccordionItemTitle,
    AccordionItemBody,
} from 'react-accessible-accordion';

import 'react-accessible-accordion/dist/fancy-example.css';

class Help extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading_dashboard: false,
            dashboard_data: {}
        };
    }

    componentDidMount() {
        document.title = "FAQ - FleetXPress"
    }

    render() {
        if(this.props.userSession.logged_in && this.props.userSession.user.user_type <= constants.user_type.oem) {
            return (
                <div className = "bkg-white h-100">
                    <Navbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className = "help-container">
                        <h1><Trans>FAQ</Trans></h1>

                            <Accordion>
                                <AccordionItem>
                                    <AccordionItemTitle>
                                        <h3 className = "float-left"><Trans>Create A Booking</Trans></h3>
                                        <i className="fas fa-chevron-down float-right"></i>
                                        <div className = "clearfix"></div>
                                    </AccordionItemTitle>
                                    <AccordionItemBody>
                                        <p><Trans>Bookings can be created from the </Trans><Link to = "/home" target="_blank" className = "link"><Trans>dashboard</Trans></Link> <Trans>or</Trans> <Link to = "/bookings" target="_blank" className = "link"><Trans>bookings page</Trans></Link>.</p>
                                    </AccordionItemBody>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemTitle>
                                        <h3 className = "float-left">Approve/Reject Bookings</h3>
                                        <i className="fas fa-chevron-down float-right"></i>
                                        <div className = "clearfix"></div>
                                    </AccordionItemTitle>
                                    <AccordionItemBody>
                                        <p><Trans>Bookings can be approved or rejected from the</Trans> <Link to = "/home" target="_blank" className = "link"><Trans>dashboard</Trans></Link> <Trans>or</Trans> <Link to = "/bookings" target="_blank" className = "link"><Trans>bookings page</Trans></Link>.</p>
                                    </AccordionItemBody>
                                </AccordionItem><Trans></Trans>
                                <AccordionItem>
                                    <AccordionItemTitle>
                                        <h3 className = "float-left"><Trans>Invite A User</Trans></h3>
                                        <i className="fas fa-chevron-down float-right"></i>
                                        <div className = "clearfix"></div>
                                    </AccordionItemTitle>
                                    <AccordionItemBody>
                                        <p><Trans>Users can be invited by clicking the add button on the navigation bar. This can be found on the top right of any screen.</Trans></p>
                                    </AccordionItemBody>
                                </AccordionItem>
                                <AccordionItem>
                                    <AccordionItemTitle>
                                        <h3 className = "float-left"><Trans>Add A Vehicle</Trans></h3>
                                        <i className="fas fa-chevron-down float-right"></i>
                                        <div className = "clearfix"></div>
                                    </AccordionItemTitle>
                                    <AccordionItemBody>
                                        <p><Trans>Vehicles can be added by clicking the add button on the navigation bar. This can be found on the top right of any screen.</Trans></p>
                                    </AccordionItemBody>
                                </AccordionItem>
                            </Accordion>

                    </div>
                    <ModalRoutes match={this.props.match} history={this.props.history}/>
                </div>
            );
        } else if(this.props.userSession.logged_in && !this.props.userSession.user.pending_survey && this.props.userSession.user.user_type == constants.user_type.user) {
            return (
                <div className = "bkg-white h-100">
                    <EUNavbar history={this.props.history} match={this.props.match} location={this.props.location} />
                    <div className = "help-container">
                        <h1>FAQ</h1>
                            <Accordion>
                                <AccordionItem>
                                    <AccordionItemTitle>
                                        <h3 className = "float-left"><Trans>Create A Booking</Trans></h3>
                                        <i className="fas fa-chevron-down float-right"></i>
                                        <div className = "clearfix"></div>
                                    </AccordionItemTitle>
                                    <AccordionItemBody>
                                    <p><Trans>Bookings can be created from the </Trans><Link to = "/home" target="_blank" className = "link"><Trans>homepage</Trans></Link>. <Trans>Select the vehicle you want to book, dates and other necessary information.</Trans></p>
                                    </AccordionItemBody>
                                </AccordionItem>
                            </Accordion>
                    </div>
                    <ModalRoutes match={this.props.match} history={this.props.history}/>
                </div>
            );
        } else {
            return (
                <div className = "bkg-white h-100 pt-24">
                    <div className = "help-container">
                        <h1><Trans>FAQ</Trans></h1>

                            <Accordion>
                                <AccordionItem>
                                    <AccordionItemTitle>
                                        <h3 className = "float-left"><Trans>Create A Booking</Trans></h3>
                                        <i className="fas fa-chevron-down float-right"></i>
                                        <div className = "clearfix"></div>
                                    </AccordionItemTitle>
                                    <AccordionItemBody>
                                    <p><Trans>Bookings can be created from the </Trans><Link to = "/home" target="_blank" className = "link"><Trans>homepage</Trans></Link>. <Trans>Select the vehicle you want to book, dates and other necessary information.</Trans></p>
                                    </AccordionItemBody>
                                </AccordionItem>
                            </Accordion>
                    </div>
                </div>
            );
        }
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(Help)